import React, {useEffect, useState} from "react";
import '../css/confirm.css'

import backArrow from '../components/assets/img/arrow-left.png'
import Background from "../components/assets/img/bg.jpg";
import {useWeb3React} from "@web3-react/core";
import {Web3Provider} from "@ethersproject/providers";
import {
    addPhetaToken,
    campaignContractAddress,
    currentChainId,
    getBusdContract,
    getCampaignContract, getPhetaTokenContract,
    Phase,
    prettyPrintBigNumber
} from "../utils";
import {BigNumber, ethers} from "ethers";

export function InvestorBuyPage({language, backHandler, showBackButton}) {
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React<Web3Provider>()
    const [busdBalance, setBusdBalance] = useState(BigNumber.from(0))
    const [price, setPrice] = useState(0)
    const [busdAllowance, setBusdAllowance] = useState(BigNumber.from(0))
    const [busdAmount, setBusdAmount] = useState(BigNumber.from(0))
    const [busdAmountRaw, setBusdAmountRaw] = useState('')
    const [phetaAmount, setPhetaAmount] = useState(0)
    const [loading, setLoading] = useState(true)
    const [publicRoundActive, setPublicRoundActive] = useState<boolean>(undefined)
    const [tgeTime, setTgeTime] = useState<Date>(undefined)

    useEffect(() => {
        (async () => {
            const busdContract = await getBusdContract(library)
            const campaignContract = await getCampaignContract(library)

            const balance = await busdContract.balanceOf(account)
            setBusdBalance(balance)

            const price = await campaignContract.priceByPhase(Phase.PUBLIC)
            setPrice(price.toNumber()/1000)

            const vestingTime = (await campaignContract.vestingStartTime()).toNumber()
            setPublicRoundActive(vestingTime > 0 && vestingTime < Date.now() / 1000)
            setTgeTime(new Date(vestingTime * 1000))

            setBusdAllowance(await busdContract.allowance(account, campaignContractAddress[currentChainId]))
            setLoading(false)
        })().then()
    }, [account])

    const busdAmountChangeHandler = (e) => {
        let amount = e.target.value
        setBusdAmountRaw(amount)

        setBusdAmount(BigNumber.from('0'))
        setPhetaAmount(0)

        if (amount) {
            try {
                amount = Number(amount.replace(",", "."))
                setBusdAmount(ethers.utils.parseEther(amount.toString()))
                setPhetaAmount(amount / price)
            } catch (e) {
                console.log(e)
            }
        }
    }

    async function unlockPhetaToken() {
        const busdContract = await getBusdContract(library)
        const unlimitedAmount = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
        const tx = await busdContract.approve(campaignContractAddress[currentChainId], unlimitedAmount)
        tx.wait().then(async (recept) => {
            setBusdAllowance(await busdContract.allowance(account, campaignContractAddress[currentChainId]))
            setLoading(false)
        })
    }

    async function buyPhetaToken() {
        const campaignContract = await getCampaignContract(library)
        const tx = await campaignContract.buy(busdAmount, price * 1000)
        tx.wait().then(async (recept) => {
            setBusdAmount(BigNumber.from(0))
            setBusdAmountRaw('')
            setPhetaAmount(0)
            setLoading(false)
        })
    }

    const unlockOrBuy = async () => {
        if (busdAmount.gt(0) && busdAmount.lt(busdBalance)) {

            setLoading(true)
            if (busdAllowance.gte(busdAmount)) {
                await addPhetaToken(await getPhetaTokenContract(library), account)
                await buyPhetaToken()
            } else {
                await unlockPhetaToken()
            }
        }
    }

    return (
        publicRoundActive
            ? (<section className={'c'} style={{backgroundImage: `url(${Background})`}}>
                <a className="c-back" onClick={backHandler}>
                    <img className={'c-back-img'} src={backArrow} alt="Back arrow"/>
                    <p className={'c-back-text'}>{language === 'ru' ? 'Назад' : 'Back'}</p>
                </a>
                <div className={'c-content'}>
                    <div className={'c-content-container'}>
                        <p className={'c-address'}>{language === 'ru' ? 'Ваш адрес' : 'Your address'}: <span>{account}</span>
                        </p>
                        <div className={'c-buy-container'}>
                            <h2 className={'c-buy-title'}>{language === 'ru' ? 'купить фета токены' : 'buy pheta tokens'}</h2>
                            <p className={'c-buy-form-amount-desc'}>{language === 'ru' ? 'Имеется' : 'Available'}: <strong>{prettyPrintBigNumber(busdBalance)} BUSD</strong>
                            </p>
                            <div className={'c-buy-form'}>
                                <div className={'c-buy-form-amount'}>
                                    <input className={'c-buy-form-amount-input'}
                                           onChange={busdAmountChangeHandler}
                                           value={busdAmountRaw}
                                           type="text"
                                           placeholder={language === 'ru' ? 'Кол-во' : 'BUSD Amount'} required/>
                                </div>
                                <div className="c-buy-form-texts">
                                    <p className={'c-buy-form-texts-one'}><span>{phetaAmount.toFixed(2)}</span> pheta</p>
                                    <p className={'c-buy-form-texts-two'}>1 pheta = {price} usd</p>
                                </div>
                            </div>
                            <div className="c-btn">
                                {loading ? ('Executing...') : (
                                    <a className={'c-btn-link'} onClick={unlockOrBuy}>
                                        {busdAmount && busdAllowance.gte(busdAmount)
                                            ? (language === 'ru' ? 'Купить' : 'Buy')
                                            : (language === 'ru' ? 'Разрешить использование BUSD' : 'Give permission to use BUSD')
                                        }
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>)
            : (<section className={'c'} style={{backgroundImage: `url(${Background})`}}>
                { showBackButton && <a className="c-back" onClick={backHandler}>
                    <img className={'c-back-img'} src={backArrow} alt="Back arrow"/>
                    <p className={'c-back-text'}>{language === 'ru' ? 'Назад' : 'Back'}</p>
                </a> }
                <div className={'c-content'}>
                    <div className={'c-content-container'}>
                        <p className={'c-address'}>
                            {publicRoundActive === undefined ? 'Executing...' :
                                (<>
                                    Public Round didn't start yet. Start date: &nbsp;
                                    {tgeTime?.getTime() ? (<span>{tgeTime.toLocaleString()}</span>) : (<>Coming soon, check for news &nbsp;
                                        <a target="_blank" href="https://t.me/phenom_en">t.me/phenom_en</a></>)}
                                </>)
                            }
                        </p>
                    </div>
                </div>
            </section>)
    )
}
